export const checkCookie = (name) => {
  const cookies = document.cookie.split('; ');
  return (
    cookies.find((cookie) => cookie.startsWith(name + '='))?.slice(Math.max(0, name.length + 1)) ||
    null
  );
};

export const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  localStorage.setItem(name, value);
  // eslint-disable-next-line unicorn/no-document-cookie
  document.cookie = name + '=' + 'onlyExp' + expires + '; path=/';
};

export const clearAllCookies = () => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const name = cookie.split('=')[0].trim();
    // eslint-disable-next-line unicorn/no-document-cookie
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
};
